import AbstractProvidedClass from "../../../shared/AbstractProvidedClass";

export default class BringToFrontAction extends AbstractProvidedClass {
    constructor(provider, element) {
        super(provider);
        this.element = element;
        this.oldIndex = this.elements.indexOf(element);
        this.newIndex = this.elements.length - 1;
    }

    finish() {
        // If the element is already at the front, discard the action
        if (this.oldIndex == this.newIndex) {
            this.actions.discard();
            return;
        }
        this.elements.move(this.oldIndex, this.newIndex);
        this.actions.finish();
    }

    undo() {
        this.elements.move(this.newIndex, this.oldIndex);
    }

    redo() {
        this.elements.move(this.oldIndex, this.newIndex);
    }
}
